export class NearDupTextGrouping {
	textGroupId: number;
	docCount: number;
	groupTitle: string;
}
